<template>
  <div>
    <vs-row>
      <vs-card
        id="loading"
        class="bg-header vs-con-loading__container"
        style="border-radius: 20px"
      >
        <div class="mt-2">
          <vs-row id="center">
            <h2 style="font-weight: 700; color: #31394d">
              Motor Cutting Rank A
              <!-- {{ buiding_name }} Building -->
            </h2> </vs-row
          ><br /><br />

          
          <vs-table hoverFlat="false" :data="mockTable">
            <template slot="thead">
              <vs-th> </vs-th>
              <vs-th v-for="i in heaherlabel" :key="i">
                {{ i }}
              </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].name">
                  <vs-button
                    @click="goto(buiding_name, tr)"
                    color="success"
                    type="flat"
                    icon="add_circle"
                    >View</vs-button
                  >
                </vs-td>
                <vs-td :data="data[indextr].id">
                  {{ data[indextr].id }}
                </vs-td>
                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>

                <vs-td :data="data[indextr].cb"> {{ data[indextr].cb }} </vs-td>
                <vs-td :data="data[indextr].mag">
                  {{ data[indextr].mag }}
                </vs-td>
                <vs-td :data="data[indextr].current.temp">
                  {{ data[indextr].current.temp }}
                </vs-td>
                <vs-td :data="data[indextr].current.x">
                  {{ data[indextr].current.x }}
                </vs-td>
                <vs-td :data="data[indextr].current.y">
                  {{ data[indextr].current.y }}
                </vs-td>
                <vs-td :data="data[indextr].current.z">
                  {{ data[indextr].current.z }}
                </vs-td>
                <vs-td :data="data[indextr].current.a_current">
                  {{
                    data[indextr].current.a_current == undefined
                      ? "-"
                      : data[indextr].current.a_current
                  }}
                </vs-td>
                <vs-td :data="data[indextr].current.b_current">
                  {{
                    data[indextr].current.b_current == undefined
                      ? "-"
                      : data[indextr].current.b_current
                  }}
                </vs-td>
                <vs-td :data="data[indextr].current.c_current">
                  {{
                    data[indextr].current.c_current == undefined
                      ? "-"
                      : data[indextr].current.c_current
                  }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-card>
    </vs-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    headerFilter: ["Code", "Name"],
    selectData: [],
    viewdata: "",
    searchHeader: "",
    selectFilterName: "",
    selectFilterCode: "",
    getDataLocation: [],
    selected: [],
    selected: [],

    heaherlabel: [
      "No.",
      "Machine Name",
      "CB.",
      "Mag.",
      "Surface Temperature",
      "X-Axis",
      "Y-Axis",
      "Z-Axis",
      "A Phase Current",
      "B Phase Current",
      "C Phase Current",
    ],
    totalRows: 1,
    currentPage: 1,
    perPage: 5,
    pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    filter: null,
    filterOn: [],
    infoModal: {
      id: "info-modal",
      title: "",
      content: "",
    },
    tables: [],
    mockTable: [],
    buiding_name: "",
  }),
  methods: {
    goto(buiding_name, item) {
      let path_name = buiding_name.replace(/\s+/g, "");
      // let path_name_machine = item.name.replace(/\s+/g, "");
      this.$session.set("data", item);
      this.$router.push({
        path: "/Factory/Machinelist/" + path_name + "/" + item.name,
      });
    },
  },
  async mounted() {
    // Set the initial number of items
    // console.log(this.$route.params.building);
    this.buiding_name = this.$route.params.building;
    // this.$vs.loading({
    //   type: "default",
    //   container: "#loading",
    // });
    // let res = await this.$API.get(
    //   `ajino-get-building/${this.$route.params.building}`
    // );

    // let res = await this.$API.get(`qcon/getmachinelist`);

    // console.log(res.data);
    // this.mockTable = res.data;

    const body = { building: "04Cutting" };
    const response = await this.$API.post("qcon/getmachinelist", body);
    this.mockTable = response.data;
    console.log(response.data);

    // this.$vs.loading.close("#loading > .con-vs-loading");
  },
  created() {},
  computed: {},
};
</script>

<style lang="scss"scoped>
#center {
  display: flex;
  align-items: center;
}
.bg-header {
  width: 100%;
  background: linear-gradient(
    180deg,
    #48c93b 0px,
    var(--background-color-sidebar) 45px,
    var(--background-color-sidebar) 100px
  );
}
</style>